import { useState, useRef, useEffect, useCallback } from "react";
import "../../../assets/css/student/AskAI.css";
import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";


// ─── SVG Icon Components ────────────────────────────────────────────────────

const Icons = {
  Questions: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="8.5" stroke="currentColor" strokeWidth="1.4"/>
      <path d="M7.5 7.8C7.5 6.4 8.6 5.5 10 5.5s2.5.9 2.5 2.3c0 1.2-.8 1.9-1.6 2.4-.5.3-.9.8-.9 1.3v.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      <circle cx="10" cy="13.5" r=".8" fill="currentColor"/>
    </svg>
  ),
  Concepts: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3 10a7 7 0 1 1 14 0" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M10 3v2M3.5 6.5l1.4 1.4M16.5 6.5l-1.4 1.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M10 10v4M8 16h4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      <circle cx="10" cy="10" r="1.5" fill="currentColor"/>
    </svg>
  ),
  CodeFix: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M6.5 7L3 10l3.5 3M13.5 7L17 10l-3.5 3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.5 5.5l-3 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  Efficiency: () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3 14l4-4 3 3 4-5 3 2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 17h14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),
  Send: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M14 2L7 9M14 2L9.5 14 7 9 2 6.5 14 2z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Code: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M5 4L1 8l4 4M11 4l4 4-4 4M9 2l-2 12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Save: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M2 2h8l2 2v8a1 1 0 01-1 1H3a1 1 0 01-1-1V2z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
      <path d="M5 2v3h4V2M4 8h6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  ),
  Copy: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect x="4" y="4" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.3"/>
      <path d="M3 10H2a1 1 0 01-1-1V2a1 1 0 011-1h7a1 1 0 011 1v1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  ),
  Plus: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  Chat: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M14 10a1 1 0 01-1 1H5l-3 3V3a1 1 0 011-1h10a1 1 0 011 1v7z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
    </svg>
  ),
  Brain: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8 2C5.8 2 4 3.6 4 5.6c0 .8.3 1.5.7 2-.4.5-.7 1.1-.7 1.8C4 11 5.3 12.5 7 13v1h2v-1c1.7-.5 3-2 3-3.6 0-.7-.3-1.3-.7-1.8.4-.5.7-1.2.7-2C12 3.6 10.2 2 8 2z" stroke="currentColor" strokeWidth="1.3"/>
      <path d="M8 5v6M6 7h4M6 9h4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  ),
  Roadmap: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="3" cy="4" r="1.5" stroke="currentColor" strokeWidth="1.2"/>
      <circle cx="13" cy="8" r="1.5" stroke="currentColor" strokeWidth="1.2"/>
      <circle cx="3" cy="12" r="1.5" stroke="currentColor" strokeWidth="1.2"/>
      <path d="M4.5 4H10a2 2 0 012 2v.5M11.5 8H6a2 2 0 00-2 2v.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  ),
  Target: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <circle cx="7" cy="7" r="5.5" stroke="currentColor" strokeWidth="1.2"/>
      <circle cx="7" cy="7" r="3" stroke="currentColor" strokeWidth="1.2"/>
      <circle cx="7" cy="7" r=".8" fill="currentColor"/>
    </svg>
  ),
  Warning: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M7 1.5L1 12h12L7 1.5z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
      <path d="M7 5.5v3M7 10v.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
    </svg>
  ),
  Sparkle: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M7 1v2M7 11v2M1 7h2M11 7h2M3 3l1.4 1.4M9.6 9.6L11 11M3 11l1.4-1.4M9.6 4.4L11 3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
      <circle cx="7" cy="7" r="2" stroke="currentColor" strokeWidth="1.2"/>
    </svg>
  ),
  BookOpen: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M7 3C5.5 2 3.5 2 2 2.5v9c1.5-.5 3.5-.5 5 .5 1.5-1 3.5-1 5-.5v-9C10.5 2 8.5 2 7 3z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
      <path d="M7 3v9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  ),
  Trash: () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M2 4h10M5 4V2.5h4V4M11 4l-.7 8H3.7L3 4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
};

// ─── KPI Widget ─────────────────────────────────────────────────────────────

function KPIWidget({ icon: Icon, label, value, accent, delta }) {
  return (
    <div className="kpi-widget" style={{ "--kpi-accent": accent }}>
      <div className="kpi-icon-wrap">
        <Icon />
      </div>
      <div className="kpi-body">
        <span className="kpi-value">{value}</span>
        <span className="kpi-label">{label}</span>
      </div>
      {delta && <span className="kpi-delta">{delta}</span>}
    </div>
  );
}

// ─── Mode Switcher ───────────────────────────────────────────────────────────

const MODES = [
  { id: "general", label: "General Help", desc: "Open-ended learning assistant", color: "#3b82f6" },
  { id: "tutor", label: "Tutor Mode", desc: "Step-by-step teaching", color: "#8b5cf6" },
  { id: "debug", label: "Debug Mode", desc: "Code fixing & analysis", color: "#ef4444" },
  { id: "roadmap", label: "Roadmap Mode", desc: "Career path guidance", color: "#10b981" },
  { id: "assignment", label: "Assignment Mode", desc: "Task & project help", color: "#f59e0b" },
];

function ModeSwitcher({ activeMode, onModeChange }) {
  return (
    <div className="mode-switcher">
      {MODES.map((m) => (
        <button
          key={m.id}
          className={`mode-btn ${activeMode === m.id ? "active" : ""}`}
          style={{ "--mode-color": m.color }}
          onClick={() => onModeChange(m.id)}
          title={m.desc}
        >
          {m.label}
        </button>
      ))}
    </div>
  );
}

// ─── Quick Actions ───────────────────────────────────────────────────────────

const QUICK_ACTIONS = [
  { label: "Explain React useEffect", mode: "tutor", prompt: "Explain React useEffect hook in detail with examples." },
  { label: "Debug my code", mode: "debug", prompt: "I have a bug in my code. Help me debug it step by step." },
  { label: "Help with assignment", mode: "assignment", prompt: "I need help understanding and completing an assignment." },
  { label: "Suggest a roadmap", mode: "roadmap", prompt: "Suggest a learning roadmap for becoming a full-stack developer." },
  { label: "Fix JavaScript error", mode: "debug", prompt: "I have a JavaScript error. Help me identify and fix it." },
];

function QuickActions({ onAction }) {
  return (
    <div className="quick-actions">
      <p className="quick-actions-label">Quick Start</p>
      <div className="quick-actions-grid">
        {QUICK_ACTIONS.map((a, i) => (
          <button key={i} className="quick-action-card" onClick={() => onAction(a)}>
            <span>{a.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

// ─── Chat Message ────────────────────────────────────────────────────────────

function ChatMessage({ msg, onSave }) {
  const [copied, setCopied] = useState(false);

  const copyCode = (code) => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (msg.role === "user") {
    return (
      <div className="msg msg-user">
        <div className="msg-avatar msg-avatar-user">You</div>
        <div className="msg-bubble msg-bubble-user">
          {msg.codeSnippet && (
            <div className="msg-code-block">
              <pre><code>{msg.codeSnippet}</code></pre>
            </div>
          )}
          <p>{msg.content}</p>
        </div>
      </div>
    );
  }

  if (msg.role === "thinking") {
    return (
      <div className="msg msg-ai">
        <div className="msg-avatar msg-avatar-ai">AI</div>
        <div className="msg-bubble msg-bubble-ai thinking-bubble">
          <span className="thinking-dot" />
          <span className="thinking-dot" />
          <span className="thinking-dot" />
        </div>
      </div>
    );
  }

  return (
    <div className="msg msg-ai">
      <div className="msg-avatar msg-avatar-ai">AI</div>
      <div className="msg-bubble msg-bubble-ai">
        <div className="ai-response">
          {msg.sections?.explanation && (
            <div className="ai-section ai-section-blue">
              <div className="ai-section-header">
                <span className="ai-section-tag">Explanation</span>
              </div>
              <p>{msg.sections.explanation}</p>
            </div>
          )}
          {msg.sections?.example && (
            <div className="ai-section ai-section-green">
              <div className="ai-section-header">
                <span className="ai-section-tag">Example</span>
              </div>
              <p>{msg.sections.example}</p>
            </div>
          )}
          {msg.sections?.code && (
            <div className="ai-section ai-section-code">
              <div className="ai-section-header">
                <span className="ai-section-tag">Code</span>
                <button className="copy-btn" onClick={() => copyCode(msg.sections.code)}>
                  <Icons.Copy /> {copied ? "Copied" : "Copy"}
                </button>
              </div>
              <pre className="code-block"><code>{msg.sections.code}</code></pre>
            </div>
          )}
          {msg.sections?.bestPractice && (
            <div className="ai-section ai-section-orange">
              <div className="ai-section-header">
                <span className="ai-section-tag">Best Practice</span>
              </div>
              <p>{msg.sections.bestPractice}</p>
            </div>
          )}
          {msg.sections?.roadmapStep && (
            <div className="ai-section ai-section-purple">
              <div className="ai-section-header">
                <span className="ai-section-tag">Roadmap Step</span>
              </div>
              <p>{msg.sections.roadmapStep}</p>
            </div>
          )}
          {msg.suggestion && (
            <div className="ai-suggestion">
              <Icons.Sparkle />
              <span>{msg.suggestion}</span>
            </div>
          )}
        </div>
        <div className="msg-actions">
          <button className="msg-action-btn" onClick={() => onSave(msg)}>
            <Icons.Save /> Save
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── AI Context Panel ────────────────────────────────────────────────────────

function AIContextPanel({ context, savedItems, onDeleteSaved }) {
  const [tab, setTab] = useState("context");

  return (
    <aside className="context-panel">
      <div className="context-panel-tabs">
        <button className={tab === "context" ? "cp-tab active" : "cp-tab"} onClick={() => setTab("context")}>
          AI Context
        </button>
        <button className={tab === "saved" ? "cp-tab active" : "cp-tab"} onClick={() => setTab("saved")}>
          Saved ({savedItems.length})
        </button>
      </div>

      {tab === "context" && (
        <div className="context-content">
          <div className="cp-card">
            <div className="cp-card-head">
              <Icons.Target />
              <span>Current Course</span>
            </div>
            <p className="cp-card-value">{context.course || "Not detected"}</p>
          </div>
          <div className="cp-card">
            <div className="cp-card-head">
              <Icons.Roadmap />
              <span>Roadmap Step</span>
            </div>
            <p className="cp-card-value">{context.roadmapStep || "—"}</p>
            <div className="cp-progress-bar">
              <div className="cp-progress-fill" style={{ width: `${context.roadmapProgress || 0}%` }} />
            </div>
            <span className="cp-progress-label">{context.roadmapProgress || 0}% complete</span>
          </div>
          <div className="cp-card">
            <div className="cp-card-head">
              <Icons.Brain />
              <span>Skill Level</span>
            </div>
            <div className="skill-badges">
              {(context.skillLevel || ["Intermediate"]).map((s, i) => (
                <span key={i} className="skill-badge">{s}</span>
              ))}
            </div>
          </div>
          <div className="cp-card cp-card-warn">
            <div className="cp-card-head">
              <Icons.Warning />
              <span>Weak Areas</span>
            </div>
            <ul className="weak-list">
              {(context.weakAreas || ["Async/Await", "State Management"]).map((w, i) => (
                <li key={i}>{w}</li>
              ))}
            </ul>
          </div>
          <div className="cp-card cp-card-suggest">
            <div className="cp-card-head">
              <Icons.Sparkle />
              <span>Suggested Next</span>
            </div>
            <p className="cp-card-value">{context.nextTopic || "React Hooks Deep Dive"}</p>
          </div>
        </div>
      )}

      {tab === "saved" && (
        <div className="saved-content">
          {savedItems.length === 0 && (
            <div className="saved-empty">
              <Icons.BookOpen />
              <p>No saved items yet</p>
              <span>Save AI responses to build your learning memory</span>
            </div>
          )}
          {savedItems.map((item, i) => (
            <div key={i} className="saved-item">
              <div className="saved-item-header">
                <span className="saved-item-tag">{item.mode}</span>
                <button className="saved-delete-btn" onClick={() => onDeleteSaved(i)}>
                  <Icons.Trash />
                </button>
              </div>
              <p className="saved-item-preview">
                {item.sections?.explanation?.slice(0, 100) || "Saved response"}...
              </p>
            </div>
          ))}
        </div>
      )}
    </aside>
  );
}

// ─── Conversation List (Left Sidebar) ───────────────────────────────────────

function ConversationList({ conversations, activeId, onSelect, onCreate }) {
  return (
    <aside className="conv-list">
      <div className="conv-list-header">
        <span className="conv-list-title">Conversations</span>
        <button className="conv-new-btn" onClick={onCreate}>
          <Icons.Plus />
        </button>
      </div>
      <div className="conv-items">
        {conversations.map((c) => (
          <button
            key={c.id}
            className={`conv-item ${activeId === c.id ? "active" : ""}`}
            onClick={() => onSelect(c.id)}
          >
            <Icons.Chat />
            <div className="conv-item-body">
              <span className="conv-item-title">{c.title}</span>
              <span className="conv-item-meta">{c.mode} · {c.count} msgs</span>
            </div>
          </button>
        ))}
      </div>
    </aside>
  );
}

// ─── AI Response Generator ───────────────────────────────────────────────────

function generateAIResponse(prompt, mode) {
  const responses = {
    general: {
      explanation: `Great question! ${prompt.slice(0, 60)}... This concept is foundational to modern web development. Understanding it deeply will unlock more advanced patterns and allow you to write cleaner, more maintainable code.`,
      example: "Consider a simple scenario: when you fetch data from an API, the flow is asynchronous. The component renders first, then the data arrives. Handling this gracefully is the key challenge.",
      code: `// Example: Fetching data gracefully\nconst [data, setData] = useState(null);\nconst [loading, setLoading] = useState(true);\n\nuseEffect(() => {\n  fetch('/api/data')\n    .then(res => res.json())\n    .then(json => {\n      setData(json);\n      setLoading(false);\n    });\n}, []);`,
      bestPractice: "Always handle loading and error states. Never assume the data is immediately available. Use TypeScript interfaces to type your API responses for better developer experience.",
      roadmapStep: "This falls under 'React Fundamentals > Data Fetching'. Next step: explore React Query or SWR for production-grade data management.",
      suggestion: "Want me to connect this to your current roadmap step on API integration?",
    },
    tutor: {
      explanation: `Let's break this down step by step. First, we need to understand WHY this pattern exists. Before React introduced hooks, managing side effects in functional components was impossible — you had to use class components.`,
      example: "Step 1: Understand the problem. Step 2: See the naive solution. Step 3: Understand why it fails. Step 4: Apply the correct pattern. This methodical approach ensures deep understanding rather than surface-level memorization.",
      code: `// Step 1 — The problem (no cleanup)\nuseEffect(() => {\n  const timer = setInterval(() => {\n    console.log('tick');\n  }, 1000);\n  // BUG: timer never cleared!\n});\n\n// Step 2 — Correct solution with cleanup\nuseEffect(() => {\n  const timer = setInterval(() => {\n    console.log('tick');\n  }, 1000);\n  return () => clearInterval(timer); // cleanup\n}, []);`,
      bestPractice: "As a tutor principle: always understand the 'why' before the 'how'. Memorizing syntax without context leads to cargo-cult programming.",
      roadmapStep: "Mastery checkpoint: Can you explain useEffect's dependency array without looking it up? If yes, move to useCallback and useMemo next.",
      suggestion: "Shall I create a mini-quiz to test your understanding of this concept?",
    },
    debug: {
      explanation: `Analyzing your code for potential issues. The most common source of bugs in this area is: unhandled async operations, missing dependency arrays, and stale closures capturing outdated state values.`,
      example: "Diagnostic approach: (1) Reproduce the bug consistently. (2) Isolate the smallest code that shows it. (3) Check console for warnings — React is very good at telling you what's wrong. (4) Verify your dependency array is complete.",
      code: `// Common bug: Stale closure\nconst [count, setCount] = useState(0);\n\n// BUG — 'count' is stale inside this closure\nuseEffect(() => {\n  const id = setInterval(() => {\n    setCount(count + 1); // always uses initial count!\n  }, 1000);\n  return () => clearInterval(id);\n}, []); // Missing 'count' in deps\n\n// FIX — use functional update\nuseEffect(() => {\n  const id = setInterval(() => {\n    setCount(prev => prev + 1); // correct!\n  }, 1000);\n  return () => clearInterval(id);\n}, []);`,
      bestPractice: "Install and use ESLint with the react-hooks plugin. It catches dependency array issues automatically before they become runtime bugs.",
      roadmapStep: "Debugging is a core skill. Log to your roadmap: 'Mastered stale closure debugging in React hooks'.",
      suggestion: "Paste your actual code and I can provide a specific diagnosis with line-by-line analysis.",
    },
    roadmap: {
      explanation: `Based on your current trajectory, here is a structured roadmap analysis. Effective learning paths are not linear — they are iterative. You build foundational knowledge, apply it in projects, hit real problems, and loop back to deepen understanding.`,
      example: "Phase 1 (Weeks 1–4): HTML, CSS, JavaScript fundamentals. Phase 2 (Weeks 5–10): React core concepts. Phase 3 (Weeks 11–16): Node.js + APIs. Phase 4 (Weeks 17–24): Full-stack projects + deployment.",
      code: `// Roadmap as code (learning architecture)\nconst roadmap = {\n  phase1: ['HTML5', 'CSS3', 'JS ES6+'],\n  phase2: ['React', 'State Mgmt', 'Routing'],\n  phase3: ['Node.js', 'Express', 'REST APIs'],\n  phase4: ['PostgreSQL', 'Auth', 'Deployment'],\n  milestones: ['Portfolio', 'OSS contrib', 'Job ready']\n};`,
      bestPractice: "Don't skip the fundamentals. Senior engineers who struggled in interviews almost always have gaps in fundamentals, not in frameworks.",
      roadmapStep: "Current recommended step: Complete 3 React projects before moving to state management libraries. Projects cement knowledge better than tutorials.",
      suggestion: "Want me to generate a personalized week-by-week plan based on your current skill level?",
    },
    assignment: {
      explanation: `For this assignment, let's approach it strategically. First, fully understand what is being asked — many students lose marks by answering a slightly different question than what was posed. Read the requirements twice before writing any code.`,
      example: "Assignment decomposition: (1) Identify inputs and outputs. (2) List constraints and requirements. (3) Plan your solution architecture. (4) Implement incrementally. (5) Test edge cases before submission.",
      code: `// Assignment scaffold pattern\n// 1. Define your data structures first\nconst inputData = [/* your input */];\n\n// 2. Write the core logic\nfunction solve(input) {\n  // Break into smaller functions\n  const processed = preProcess(input);\n  const result = mainLogic(processed);\n  return postProcess(result);\n}\n\n// 3. Test with provided examples\nconsole.log(solve(inputData));`,
      bestPractice: "Always test your solution against the provided examples before submitting. Then test edge cases: empty input, maximum input size, and boundary conditions.",
      roadmapStep: "Assignments build applied skills. Mark this topic as 'applied' in your roadmap — it's more valuable than tutorial completion.",
      suggestion: "Share your assignment requirements and I will help you build a complete solution strategy.",
    },
  };

  return responses[mode] || responses.general;
}

// ─── Main App ────────────────────────────────────────────────────────────────

let msgIdCounter = 100;
let convIdCounter = 10;

const initialConversations = [
  { id: 1, title: "React Hooks Overview", mode: "tutor", count: 6 },
  { id: 2, title: "Fix async bug", mode: "debug", count: 4 },
  { id: 3, title: "Frontend Roadmap", mode: "roadmap", count: 3 },
];

const initialMessages = [
  {
    id: 1,
    role: "ai",
    mode: "general",
    sections: {
      explanation: "Welcome to Techify AI — your personal learning co-pilot. I can help you understand concepts, debug code, plan your learning roadmap, and work through assignments. Choose a mode above or use a quick action to get started.",
      bestPractice: "The more context you provide about what you're building or learning, the more precise and useful my responses will be.",
      roadmapStep: "Start by selecting a mode that matches your current need: Tutor Mode for learning, Debug Mode for fixing code, or Roadmap Mode for career guidance.",
    },
    suggestion: "Select a mode above or click a quick action to get started.",
  },
];

export default function AskAIPage() {
  const [conversations, setConversations] = useState(initialConversations);
  const [activeConvId, setActiveConvId] = useState(1);
  const [messages, setMessages] = useState(initialMessages);
  const [activeMode, setActiveMode] = useState("general");
  const [input, setInput] = useState("");
  const [codeInput, setCodeInput] = useState("");
  const [showCodeInput, setShowCodeInput] = useState(false);
  const [isThinking, setIsThinking] = useState(false);
  const [savedItems, setSavedItems] = useState([]);
  const [kpis] = useState({ questions: 142, concepts: 38, fixes: 27, efficiency: 84 });
  const chatEndRef = useRef(null);

  const aiContext = {
    course: "React — Advanced Patterns",
    roadmapStep: "Hooks & State Management",
    roadmapProgress: 62,
    skillLevel: ["Intermediate", "Frontend"],
    weakAreas: ["Async/Await", "useCallback"],
    nextTopic: "React Query & SWR",
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = useCallback(async () => {
    const text = input.trim();
    if (!text && !codeInput.trim()) return;

    const userMsg = {
      id: ++msgIdCounter,
      role: "user",
      content: text,
      codeSnippet: codeInput.trim() || null,
    };

    setMessages((prev) => [...prev, userMsg, { id: ++msgIdCounter, role: "thinking" }]);
    setInput("");
    setCodeInput("");
    setShowCodeInput(false);
    setIsThinking(true);

    await new Promise((r) => setTimeout(r, 1400 + Math.random() * 800));

    const sections = generateAIResponse(text, activeMode);
    const aiMsg = {
      id: ++msgIdCounter,
      role: "ai",
      mode: activeMode,
      sections,
      suggestion: sections.suggestion,
    };

    setMessages((prev) => [...prev.filter((m) => m.role !== "thinking"), aiMsg]);
    setIsThinking(false);

    setConversations((prev) =>
      prev.map((c) => (c.id === activeConvId ? { ...c, count: c.count + 2 } : c))
    );
  }, [input, codeInput, activeMode, activeConvId]);

  const handleQuickAction = (action) => {
    setActiveMode(action.mode);
    setInput(action.prompt);
  };

  const handleSave = (msg) => {
    setSavedItems((prev) => [...prev, { ...msg, savedAt: new Date() }]);
  };

  const handleDeleteSaved = (idx) => {
    setSavedItems((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleNewConversation = () => {
    const newConv = {
      id: ++convIdCounter,
      title: "New Conversation",
      mode: activeMode,
      count: 0,
    };
    setConversations((prev) => [newConv, ...prev]);
    setActiveConvId(newConv.id);
    setMessages(initialMessages);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const showQuickActions = messages.length <= 1;
  const activeModeDef = MODES.find((m) => m.id === activeMode);

  return (
    <MyStudentLayout>
    <div className="ask-ai-root">
      {/* Header */}
      <header className="ask-ai-header">
        <div className="header-brand">
          <div className="header-logo">
            <Icons.Brain />
          </div>
          <div>
            <h1 className="header-title">Ask Techify AI</h1>
            <p className="header-subtitle">Your personal learning co-pilot</p>
          </div>
        </div>
        <div className="kpi-row">
          <KPIWidget icon={Icons.Questions} label="Questions Asked" value={kpis.questions} accent="#3b82f6" delta="+12 today" />
          <KPIWidget icon={Icons.Concepts} label="Concepts Learned" value={kpis.concepts} accent="#8b5cf6" delta="+3 this week" />
          <KPIWidget icon={Icons.CodeFix} label="Code Fixes" value={kpis.fixes} accent="#10b981" delta="+2 today" />
          <KPIWidget icon={Icons.Efficiency} label="Learning Efficiency" value={`${kpis.efficiency}%`} accent="#f59e0b" delta="Up 4%" />
        </div>
      </header>

      {/* Mode Switcher */}
      <div className="mode-bar">
        <ModeSwitcher activeMode={activeMode} onModeChange={setActiveMode} />
        <div className="mode-indicator" style={{ "--mode-color": activeModeDef.color }}>
          <span className="mode-dot" />
          <span>{activeModeDef.desc}</span>
        </div>
      </div>

      {/* Main Layout */}
      <main className="ask-ai-main">
        {/* Left: Conversation List */}
        <ConversationList
          conversations={conversations}
          activeId={activeConvId}
          onSelect={(id) => setActiveConvId(id)}
          onCreate={handleNewConversation}
        />

        {/* Center: Chat Window */}
        <section className="chat-window">
          <div className="chat-messages">
            {messages.map((msg) => (
              <ChatMessage key={msg.id} msg={msg} onSave={handleSave} />
            ))}
            {showQuickActions && <QuickActions onAction={handleQuickAction} />}
            <div ref={chatEndRef} />
          </div>

          {/* Input Area */}
          <div className="chat-input-area">
            {showCodeInput && (
              <div className="code-input-wrap">
                <div className="code-input-header">
                  <Icons.Code />
                  <span>Code Snippet</span>
                  <button className="close-code-btn" onClick={() => setShowCodeInput(false)}>×</button>
                </div>
                <textarea
                  className="code-textarea"
                  value={codeInput}
                  onChange={(e) => setCodeInput(e.target.value)}
                  placeholder="Paste your code here..."
                  rows={5}
                />
              </div>
            )}
            <div className="chat-input-row">
              <button
                className={`input-action-btn ${showCodeInput ? "active" : ""}`}
                onClick={() => setShowCodeInput((v) => !v)}
                title="Add code snippet"
              >
                <Icons.Code />
              </button>
              <textarea
                className="chat-input"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Ask anything about coding, assignments, or roadmaps…"
                rows={1}
              />
              <button
                className="send-btn"
                onClick={handleSend}
                disabled={isThinking || (!input.trim() && !codeInput.trim())}
              >
                <Icons.Send />
              </button>
            </div>
          </div>
        </section>

        {/* Right: AI Context Panel */}
        <AIContextPanel
          context={aiContext}
          savedItems={savedItems}
          onDeleteSaved={handleDeleteSaved}
        />
      </main>
    </div>
    </MyStudentLayout>
  );
}